import React, { useCallback, useMemo } from "react";
import { Pressable, View } from "react-native";
import { useI18nMessage } from "@lookiero/i18n-react";
import { AnimatedChecked } from "../../../../atom/animatedChecked/AnimatedChecked";
import { Button } from "../../../../atom/button/Button";
import { useAnswerForId } from "../../behaviours/useAnswers";
import { useAnswersValidation } from "../../behaviours/useAnswersValidation";
import { QuestionItemState, useQuestionItemState } from "../../behaviours/useQuestionItemState";
import { style as fitButtonWithIconQuestionItemStyle } from "./FitButtonWithIconQuestionItem.style";
const ICON = {
    ["quiz.icon.dresses"]: "dress_large",
    ["style_profile.icon.dresses"]: "dress_large",
    ["quiz.icon.shirts"]: "shirt_large",
    ["style_profile.icon.shirts"]: "shirt_large",
    ["quiz.icon.t_shirts"]: "t_shirt_round_large",
    ["style_profile.icon.t_shirts"]: "t_shirt_round_large",
    ["quiz.icon.trousers"]: "trousers_large",
    ["style_profile.icon.trousers"]: "trousers_large",
    ["quiz.icon.skirts"]: "skirt_large",
    ["style_profile.icon.skirts"]: "skirt_large",
    ["quiz.icon.outwear"]: "outer_garment_large",
    ["style_profile.icon.outwear"]: "outer_garment_large",
    ["quiz.icon.bags"]: "bag_large",
    ["style_profile.icon.bags"]: "bag_large",
    ["quiz.icon.foulards"]: "scarf_large",
    ["style_profile.icon.foulards"]: "scarf_large",
    ["quiz.icon.footwear"]: "shoes_large",
    ["style_profile.icon.footwear"]: "shoes_large",
    ["quiz.icon.shirt_regular_fit"]: "shirt_regular_fit",
    ["style_profile.icon.shirt_regular_fit"]: "shirt_regular_fit",
    ["quiz.icon.shirt_slim_fit"]: "shirt_slim_fit",
    ["style_profile.icon.shirt_slim_fit"]: "shirt_slim_fit",
    ["quiz.icon.trouser_regular_fit"]: "trouser_regular_fit",
    ["style_profile.icon.trouser_regular_fit"]: "trouser_regular_fit",
    ["quiz.icon.trouser_relaxed_fit"]: "trouser_relaxed_fit",
    ["style_profile.icon.trouser_relaxed_fit"]: "trouser_relaxed_fit",
    ["quiz.icon.trouser_skinny_fit"]: "trouser_skinny_fit",
    ["style_profile.icon.trouser_skinny_fit"]: "trouser_skinny_fit",
    ["quiz.icon.trouser_slim_fit"]: "trouser_slim_fit",
    ["style_profile.icon.trouser_slim_fit"]: "trouser_slim_fit",
    ["quiz.icon.trouser_tapered_fit"]: "trouser_tapered_fit",
    ["style_profile.icon.trouser_tapered_fit"]: "trouser_tapered_fit",
};
const FitButtonWithIconQuestionItem = ({ domain, segment, question, questionParentId, }) => {
    const style = useMemo(() => fitButtonWithIconQuestionItemStyle(), []);
    const titleText = useI18nMessage({ domain, id: question.translationKey, values: { segment: segment.toLowerCase() } });
    const { answer, onChange } = useAnswerForId({ id: questionParentId });
    const selectedAnswer = answer && answer.find((id) => id === question.id);
    const { validateMaxAnswers } = useAnswersValidation();
    const state = useQuestionItemState({ questionParentId, question });
    const handleOnChange = useCallback(() => {
        onChange({ questionId: question.id, answer: selectedAnswer ? undefined : question.id });
        validateMaxAnswers();
    }, [onChange, question.id, selectedAnswer, validateMaxAnswers]);
    const checked = state === QuestionItemState.SELECTED;
    const icon = ICON[question.metadata.icon];
    return (React.createElement(View, { style: style.container, testID: "fit-button-icon-question-item" },
        React.createElement(Button, { checked: checked, component: Pressable, icon: icon, style: { button: style.button, icon: style.icon, text: style.text }, testID: question.id, title: titleText, onPress: handleOnChange },
            React.createElement(AnimatedChecked, { checked: checked }))));
};
export { FitButtonWithIconQuestionItem };
